import { ProjectStatusEnum } from 'gql/graphql';

export const useStatusChangeDialogMessage = (nextStatus?: ProjectStatusEnum) => {
    if (nextStatus === ProjectStatusEnum.Delayed) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «Отложен» дальнейшая работа по Проекту будет недоступна.
                </div>
                <div>Вы уверены, что хотите изменить статус?</div>
            </>
        );
    }

    if (nextStatus === ProjectStatusEnum.Completed) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «Завершен» дальнейшая работа с Проектом будет недоступна.
                </div>
                <div>Вы уверены, что хотите изменить статус?</div>
            </>
        );
    }

    if (nextStatus === ProjectStatusEnum.Calculated) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «Сформирован» дальнейшая работа с Расчетом НМЦ будет недоступна.
                </div>
                <div>Вы уверены, что хотите изменить статус?</div>
            </>
        );
    }

    return <div> Вы уверены, что хотите изменить статус?</div>;
};
